// TODO placeholder 404 screen, which shouldn't come up, but if we use it we'll need designs, styles, translations
function NotFound({ translations }) {
  const t = (key) => translations[key] || key;
  const style = { cursor: 'pointer', border: 'none', background: 'none', padding: 0, textDecoration: 'underline' };
  const reloadPage = () => window.location.reload();
  return (
    <div style={{ margin: '2rem', textAlign: 'center' }}>
      <h3>{t('Sorry, something went wrong')}</h3>
      <p>
        <button style={style} onClick={reloadPage}>
          {t('Please try again later')}
        </button>
      </p>
    </div>
  );
}

export default NotFound;
